import { render, staticRenderFns } from "./ot-wizard-wrapper.vue?vue&type=template&id=2dd8e49a&scoped=true&"
import script from "./ot-wizard-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-wizard-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-wizard-wrapper.vue?vue&type=style&index=0&id=2dd8e49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8e49a",
  null
  
)

export default component.exports